window.addEventListener('click', (e) => {
  const removeButton = e.target.closest('.cart-item__remove')
  const quantityButton = e.target.closest('.cart-bundle__quantity')

  if ((!!!removeButton || !!!removeButton.closest('.cart-bundle')) && !!!quantityButton) return;

  e.preventDefault();

  if (removeButton) removeBundle(removeButton)

  if (quantityButton) updateQuantity(quantityButton.closest('.cart-item__quantity.cart-bundle'))

})

var reRenderShopifySections = (response, selector = "[data-rerender]") => {
  return Object.keys(response.sections).forEach((key) => {
    const updatedNode = new DOMParser().parseFromString(response.sections[key], "text/html").querySelectorAll(selector);
    document.querySelector(`[id^="shopify-section-"][id*="${key}"]`)?.querySelectorAll(selector).forEach((node, index) => {
      node.replaceWith(updatedNode[index]);
    });
  });
};

async function updateQuantity(quantityButton) {
  return;
  let keys = quantityButton.dataset.keys.split('%|%')
  let quantities = quantityButton.dataset.quantities.split('%|%')
  let bundleQuantity = quantityButton._value

  const res = await Promise.all()

}

async function removeBundle(removeButton) {
  let bundleItems = removeButton.dataset.keys.split('%|%').slice(0, -1);

  for (const item of bundleItems) {

    document.querySelector('body').classList.add('loading')

    await removeItem(item);

    document.querySelector('body').classList.remove('loading')
  }
}

async function removeItem(itemKey) {

  let sections = "mini-cart,header,cart-notification,main-cart"

  const request = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      sections,
      ...{ id: itemKey, quantity: 0 }
    })
  })

  const response = await request.json()

  reRenderShopifySections(response)

}


